/*  MUI  */
import { Box } from '@mui/material';

/*  Shared  */
import { PageTitle } from 'application/Shared/Components/App';
import { Contracts } from 'application/Shared/Pages';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const PartnerContracts = () => {
    const { t } = useTranslation();

    return (
        <Box>
            <PageTitle title={t('ContractManagement.title')} />
            <Contracts partner />
        </Box>
    );
};
